import { endOfTomorrow, startOfYesterday } from "date-fns";
import { z } from "zod";

export const selectedTrainSchema = z
  .object({
    trainId: z.string(),
    nominalDate: z.coerce
      .date()
      // TODO: This doesn't play so well with DayPlan overriding
      .refine((it) => it >= startOfYesterday() && it <= endOfTomorrow()),
  })
  .transform((selectedTrain) => (selectedTrain.trainId ? selectedTrain : null));

export type SelectedTrain = z.infer<typeof selectedTrainSchema>;
